var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "comment-content-replace-extra-options" },
    [
      _c(
        "div",
        { staticClass: "comment-content-replace-rows" },
        [
          _vm._l(_vm.rows, function (row, index) {
            return [
              _c("ContentReplaceRow", {
                key: row.key,
                attrs: { row: row },
                on: {
                  change: function ($event) {
                    return _vm.handleRowChange(row, $event)
                  },
                  delete: function ($event) {
                    return _vm.handleRowDelete(row)
                  },
                },
              }),
              _vm._v(" "),
              index < _vm.rows.length - 1
                ? _c("div", {
                    key: row.key,
                    staticClass: "comment-content-replace-separator",
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "VButton",
        {
          staticClass: "comment-content-replace-add-row",
          on: { click: _vm.handleRowAdd },
        },
        [
          _c("VIcon", { attrs: { size: 14, icon: "mdi-plus" } }),
          _vm._v("\n    添加配置\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }